import { render, staticRenderFns } from "./SocketDevice.vue?vue&type=template&id=5b8b84a5"
import script from "./SocketDevice.vue?vue&type=script&lang=js"
export * from "./SocketDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports